module.exports = __webpack_public_path__ + "d28857c687367b0333da4e3a2f0e33ab.svg";